import { LinkProps } from 'next/link';

import Link from 'next/link';
import React from 'react';
import { cn } from '@wwe-portal/ui/lib/lib';

export const PrimaryLink = ({
  children,
  className,
  ...props
}: LinkProps &
  Omit<React.AnchorHTMLAttributes<HTMLAnchorElement>, keyof LinkProps>) => {
  return (
    <Link
      {...props}
      className={cn('text-text600 hover:text-green800', className)}
    >
      {children}
    </Link>
  );
};
